export function formatarValorParaReal(valor) {
    if (valor === null || valor === undefined || typeof valor !== 'number') {
        return '';
    }
   
    const formato = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });

    return formato.format(valor);
}